import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import ModalComponent from '../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../contexts/ModalContext/ModalContext';
import { BulkAlertingResourceType } from '../../utility/types/BulkAlertingResourceType';

function CannotDeleteInUseModal(props) {
  const {
    setModalJSX,
    itemName,
    itemType,
    handleClose,
  } = props;
  const [show, setShow] = useState(true);
  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
    handleClose();
  };

  const getItemTypeDisplayName = (type) => {
    switch (type) {
      case BulkAlertingResourceType.SHARED_THRESHOLD: return 'Shared Threshold';
      case BulkAlertingResourceType.QUIET_TIME: return 'Quiet Time';
      case BulkAlertingResourceType.NOTIFICATION_GROUP: return 'Notification Group';
      default: return '';
    }
  };

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Icon
            icon="triangle-exclamation"
            className="text-warning"
          />
          {' '}
          Cannot Delete
          {' '}
          {itemName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col">
            <p>
              {getItemTypeDisplayName(itemType)}
              {' '}
              &apos;
              {itemName}
              &apos;
              {' '}
              cannot be deleted because it is attached to one or more alerts.
              If you would like to delete this
              {' '}
              {itemType && getItemTypeDisplayName(itemType).toLowerCase()}
              , first please remove it from any associated alerts.
            </p>
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

CannotDeleteInUseModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(CannotDeleteInUseModal);
